/* template */
<template minapp="mpx" xlang="wxml"><Drawer :externStyle="(customStyle)" :headerStyle="(headerStyle)" :show="(show)" showMask :showCloseBtn="(false)" @close="closeDrawer" v-if="(!repeat)"><div class="container"><hlText :text="(hightlightText)" color="#666" hlColor="#FF6400" :hlStyle="(hlStyle)" class="hl-text"/><div class="price-difference">是否再次提升抢票速度至{{ recommendAccPackageName }}抢票，+{{ priceDifference }}元/单</div><div class="diff-status-card"><div class="cur-pack"><div class="title">{{ curAccProgressName }}</div><div class="sub-title">领先{{ curAccProgressPercent }}%的用户</div></div><div class="recommend-pack"><div class="title">{{ recommendAccPackageName }}</div><div class="sub-title">领先<div class="number">{{ recommendAccPackagePercent }}</div><div class="unit">%</div>的用户</div><mpx-image src="https://ut-static.udache.com/webx/sfc/bDw1P-JhbkeGwgWVcIE7r.png" class="up-icon"/></div></div><div class="tip-container"><div class="tips"><div v-for="(item, index) in (popRightsTips)" :key="item.index" class="tip"><mpx-image :src="(item.icon)" class="icon" v-if="(item.icon)"/><div class="text" v-if="(item.title)">{{ item.title }}</div></div></div></div><div class="btn-area"><Button @click="closeDrawerAndSubmit" :externClass='["btn disagree"].join(" ")'>否</Button><Button @click="confirm" :externClass='["btn agree"].join(" ")'>是</Button></div></div></Drawer></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m1f2c86a0"}'>
  @font-face
    font-family Bebas Neue
    src url('https://ut-static.udache.com/webx/sfc/6TZbL8WaY5143mEBV1QO__BebasNeue-1-Medium.otf')
  .container
    position relative
    box-sizing border-box
    padding 32px 20px 34px 20px
    display flex
    flex-direction column
    align-items center
    background linear-gradient(106deg, #FFF5EE 2%, #E5F9F6 85%)
    .hl-text
      font-size 14px
      line-height 20px
      margin-bottom 1.5px
    .price-difference
      font-size 14px
      line-height 20px
      color #666
      font-family PingFangSC-Regular
      font-weight 400
      margin-bottom 28px
    .diff-status-card
      height 125px
      width 275px
      display flex
      align-items flex-end
      margin-bottom 15px
      .cur-pack
        flex-shrink 0
        width 125px
        height 108px
        display flex
        flex-direction column
        justify-content center
        align-items center
        background #C2EEE5
        box-sizing border-box
        border 1px solid #b8e1d0
        color #3BB6A2
        border-radius 11.57px
        .title
          font-size 20px
          line-height 1
          font-family PingFangSC-Semibold
          font-weight 600
          margin-bottom 15px
        .sub-title
          font-size 12.5px
          line-height 1
          font-family PingFangSC-Medium
          font-weight 500
      .recommend-pack
        flex-shrink 0
        position relative
        width 160px
        height 100%
        display flex
        flex-direction column
        justify-content center
        align-items center
        background linear-gradient(330deg, #FF5900 5%, #FF8C00 85%)
        border 0.5px solid #FFED4C
        z-index 1
        transform translateX(-10px)
        color #fff
        border-radius 11.57px
        .title
          font-size 25px
          line-height 28px
          font-family PingFangSC-Semibold
          font-weight 600
          margin-bottom 15px
        .sub-title
          font-size 14px
          font-family PingFangSC-Medium
          font-weight 500
          display flex
          align-items baseline
          .number
            font-family Barlow Semi Condensed
            font-size 25px
            line-height 1
            font-weight 400
            color #FFED4C
          .unit
            font-family Bebas Neue
            font-size 25px
            line-height 1
            font-weight 400
            color #FFED4C
        .up-icon
          z-index 1
          position absolute
          width 50px
          height 33px
          left -25.5px
          bottom -4px
    .tip-container
      width 275px
      display flex
      justify-content center
      align-items center
      border-radius 8px
      background rgba(255, 255, 255, 0.7)
      padding 12px 33px
      box-sizing border-box
      margin-bottom 28px
      .tips
        width 100%
        display flex
        justify-content space-between
        align-items center
        flex-wrap wrap
        .tip
          font-size 13px
          line-height 20px
          color #333
          display flex
          align-items center
          .icon
            height 16px
            width 16px
            margin-right 4px
          .text
            font-size 13px
            line-height 20px
            font-family PingFangSC-Medium
            font-weight 500
    .btn-area
      width 100%
      display flex
      justify-content space-between
      .btn
        border-radius 8px
        box-sizing border-box
        display flex
        justify-content center
        align-items center
        font-size 16px
        padding 14px 0
      .disagree
        color #999
        font-family PingFangSC-Medium
        font-weight 500
        width 109px
        margin-right 8px
        border 1px solid #ccc
      .agree
        font-family PingFangSC-Semibold
        font-weight 600
        background #FF6400
        color #fff
        flex 1
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m1f2c86a0"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./scramble-retention-drawer.mpx.js?isComponent&outputPath=components%2Fscramble-retention-drawer1f2c86a0%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./scramble-retention-drawer.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fscramble-retention-drawer1f2c86a0%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m1f2c86a0"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/scramble-retention-drawer1f2c86a0/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'Drawer':getComponent(require("../../../../node_modules/@didi/spring-ui/ts-drawer/index.mpx?isComponent&outputPath=components%2Findex76c11e5c%2Findex")),'Button':getComponent(require("../../../../node_modules/@didi/spring-ui/ts-button/index.mpx?isComponent&outputPath=components%2Findex9b0ba146%2Findex")),'spring-icon':getComponent(require("../../../../node_modules/@didi/spring-icon/index/index.mpx?isComponent&outputPath=components%2Findex4d1d0d54%2Findex")),'hlText':getComponent(require("../../../../node_modules/@didi/spring-ui/hl-text/index.mpx?isComponent&outputPath=components%2Findex1ae4dab3%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
